require("./bootstrap");

// imports
import { Modal } from "bootstrap";
require("aos/dist/aos.js");
import Swiper from "swiper/bundle";
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import fslightbox from "fslightbox";

// Page transition
let links = document.querySelectorAll(
    ".link, .menu__link, .badge-link, .logo-link, .footernav-link, .regular-link",
);
if (links) {
    links.forEach((link) => {
        link.onclick = (e) => {
            let body = document.querySelector("body");
            e.preventDefault();
            const anchor = e.target.closest("a");
            const href = anchor
                ? anchor.href
                : e.srcElement.href ||
                  (e.srcElement.parentElement &&
                      e.srcElement.parentElement.href);
            // in async handler (ajax/timer) do these actions:
            setTimeout(function () {
                if (body.classList.contains("fade-out")) {
                    if (href) {
                        window.location = href;
                    }
                }
            }, 50);
            body.classList.add("fade-out");
        };
    });
}

// AOS
window.aos = require("aos");
aos.init({
    startEvent: "DOMContentLoaded",
    easing: "ease-in",
    delay: 100,
    once: false,
    mirror: true,
});

// Lightbox instance
refreshFsLightbox();

// Temporary modal
if (document.querySelector("#temporaryModal") != null) {
    let myModal = new Modal(document.getElementById("temporaryModal"));
    myModal.show();
}

// Swiper
if (document.querySelector(".swiper-masthead") != null) {
    var swiper = new Swiper(".swiper-masthead", {
        keyboard: true,
        speed: 2500,
        parallax: true,
        autoplay: {
            delay: 6500,
        },
        effect: "slide",
        loop: true,
        navigation: {
            nextEl: ".carousel-control-next",
            prevEl: ".carousel-control-prev",
        },
    });
}

if (document.querySelector(".swiper-kunden") != null) {
    var swiper = new Swiper(".swiper-kunden", {
        history: {
            key: "#kundenstimmen",
            replaceState: true,
        },
        preventClicks: false,
        //preventClicksPropagation: false,
        draggable: false,
        simulateTouch: false,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 800,
        effect: "slide",
        loop: true,
        navigation: {
            nextEl: ".carousel-control-next",
            prevEl: ".carousel-control-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                centeredSlides: false,
            },
            992: {
                slidesPerView: 1,
                centeredSlides: false,
            },
            1400: {
                slidesPerView: 2,
                centeredSlides: false,
            },
        },
    });
}

if (document.querySelector(".swiper-referenzen") != null) {
    var swiper = new Swiper(".swiper-referenzen", {
        preventClicks: false,
        //draggable: false,
        //simulateTouch: false,
        slideToClickedSlide: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 2500,
        loop: true,
        navigation: {
            nextEl: ".carousel-control-next",
            prevEl: ".carousel-control-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                centeredSlides: false,
            },
            992: {
                slidesPerView: 2,
                centeredSlides: false,
            },
            1200: {
                slidesPerView: 3,
                centeredSlides: false,
            },
        },
    });
}

if (document.querySelector(".swiper-masthead2") != null) {
    var swiper = new Swiper(".swiper-masthead2", {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 3000,
        loop: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        breakpoints: {
            992: {
                slidesPerView: "auto",
            },
            1920: {
                slidesPerView: "auto",
            },
            1921: {
                slidesPerView: 2,
            },
        },
    });
}

if (document.querySelector(".swiper-job") != null) {
    var swiper = new Swiper(".swiper-job", {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 3000,
        loop: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        breakpoints: {
            992: {
                slidesPerView: "auto",
            },
            1920: {
                slidesPerView: "auto",
            },
            1921: {
                slidesPerView: "auto",
            },
        },
    });
}

if (document.querySelector(".swiper-job2") != null) {
    var swiper = new Swiper(".swiper-job2", {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 8000,
        loop: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        breakpoints: {
            992: {
                slidesPerView: "auto",
            },
            1920: {
                slidesPerView: "auto",
            },
            1921: {
                slidesPerView: "auto",
            },
        },
    });
}

if (document.querySelector(".swiper-timeline") != null) {
    var swiper = new Swiper(".swiper-timeline", {
        direction: "horizontal",
        loop: false,
        speed: 1600,
        lazy: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                var year = document
                    .querySelectorAll(".swiper-slide")
                    [index].getAttribute("data-year");
                return '<span class="' + className + '">' + year + "</span>";
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        autoHeight: true,
        slidesPerView: "auto",
        breakpoints: {
            992: {
                direction: "vertical",
            },
        },
    });
}

if (document.querySelector(".swiper-member") != null) {
    var swiper = new Swiper(".swiper-member", {
        preventClicks: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        effect: "slide",
        loop: true,
        resizeObserver: true,
        navigation: {
            nextEl: ".carousel-control-next",
            prevEl: ".carousel-control-prev",
        },
    });
}

if (document.querySelector(".swiper-jobs") != null) {
    var swiper = new Swiper(".swiper-jobs", {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
            },
            992: {
                slidesPerView: 1,
            },
        },
        on: {
            init: function () {
                // Video-Event-Listener hinzufügen
                setupVideoControls(this);
            },
        },
    });

    function setupVideoControls(swiperInstance) {
        const videos = document.querySelectorAll(".swiper-jobs video");

        videos.forEach((video) => {
            // Video startet zu spielen
            video.addEventListener("play", function () {
                swiperInstance.autoplay.stop();
            });

            // Video wird pausiert oder gestoppt
            video.addEventListener("pause", function () {
                swiperInstance.autoplay.start();
            });

            // Video ist zu Ende
            video.addEventListener("ended", function () {
                swiperInstance.autoplay.start();
            });

            // Video wird gestoppt (seeked to start)
            video.addEventListener("seeking", function () {
                if (video.currentTime === 0) {
                    swiperInstance.autoplay.start();
                }
            });
        });

        // Wenn Slide gewechselt wird, alle anderen Videos pausieren
        swiperInstance.on("slideChange", function () {
            videos.forEach((video) => {
                if (!video.paused) {
                    video.pause();
                    video.currentTime = 0;
                }
            });
        });
    }
}

// Quick Nav Mobile on Scroll
var quickNav = document.querySelector(".quick-nav__mobile");

function windowScroll() {
    if (!quickNav) {
        return;
    }
    quickNav.classList.toggle(
        "quick-nav__mobile__scroll",
        quickNav.scrollTop > 50 || document.documentElement.scrollTop > 50,
    );
}

if (quickNav) {
    window.onscroll = function () {
        windowScroll();
    };
}

// Typing effect
if (document.querySelector("#typeWriterUnternehmen") != null) {
    var i = 0;
    var txtUnternehmen =
        "Wir nehmen uns Zeit, um Ihre Wünsche und Vorhaben zu verstehen und die Ausführung sorgfältig und vorausschauend zu planen. Und wir setzen bei der Durchführung das Wertvollste für Sie ein, das wir haben: Unser Team aus erfahrenen und hervorragend ausgebildeten Mitarbeitern.";
    var speed = 50;

    var typeWriter1 = document
        .getElementById("typeWriterUnternehmen")
        .addEventListener("click", typeWriterUnternehmen);

    function typeWriterUnternehmen() {
        if (i < txtUnternehmen.length) {
            document.getElementById("typing-effect").innerHTML +=
                txtUnternehmen.charAt(i);
            i++;
            setTimeout(typeWriterUnternehmen, speed);
        }
    }
}

if (document.querySelector("#typeWriterAussenanstrich") != null) {
    var i = 0;
    var txtAussenanstrich = "Wir erklären es Ihnen:";
    var speed = 50;

    var typeWriter2 = document
        .getElementById("typeWriterAussenanstrich")
        .addEventListener("click", typeWriterAussenanstrich);

    function typeWriterAussenanstrich() {
        if (i < txtAussenanstrich.length) {
            document.getElementById("typing-effect").innerHTML +=
                txtAussenanstrich.charAt(i);
            i++;
            setTimeout(typeWriterAussenanstrich, speed);
        }
    }
}

// Masonry (Referenzen)
// init Masonry
if (document.querySelector(".grid") != null) {
    var grid = document.querySelector(".grid");

    if (grid) {
        var msnry = new Masonry(grid, {
            itemSelector: ".grid-item",
            columnWidth: ".grid-sizer",
            gutter: ".gutter-sizer",
            percentPosition: true,
        });

        imagesLoaded(grid).on("progress", function () {
            // layout Masonry after each image loads
            msnry.layout();
        });
    }
}

// Parallax BG
window.onload = function () {
    // Parallax function
    var cloud = $("[class*='cloud-']");
    $(window).scroll(function () {
        var x = $(this).scrollTop();
        var offsetBG = parseInt(-x / 10);
        var widthVal = `calc(50% + ${offsetBG}px)`;
        cloud.css("background-position-y", widthVal);
    });
};

// Smooth Scroll
// Select all links with hashes
$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, "") ==
                this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length
                ? target
                : $("[name=" + this.hash.slice(1) + "]");
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $("html, body").animate(
                    {
                        scrollTop: target.offset().top,
                    },
                    1000,
                    function () {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) {
                            // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    },
                );
            }
        }
    });

// Team Area
// Tooltips for Team
if (document.querySelector("#team") != null) {
    $(document).ready(function () {
        $(".team .row").each(function () {
            $(this).find(".team-member").randomtest().addClass("active");
        });

        $(".team .dh-tooltip").dhTooltip(true);
    });

    //(function( $ ) {

    $.fn.dhTooltip = function (isTeam) {
        // Setup options
        var isTeam = isTeam || false;

        return this.each(function () {
            var $this = $(this),
                $tooltip = $this.find(".tooltip");

            var position_tooltip = function () {
                var position = $this.offset();
                position.left >= $(window).width() / 2
                    ? $tooltip.addClass("left")
                    : $tooltip.removeClass("left");
            };

            var init_tooltip = function () {
                //$tooltip.on( 'tap ', hide_tooltip );
                if (!isTeam) {
                    $this.on("mouseleave", hide_tooltip);
                }

                $this.bind("tap", check_status);
                $this.bind("mouseenter", show_tooltip);

                $(window).on("resize", position_tooltip);
                position_tooltip();
            };

            var hide_tooltip = function () {
                $this.removeClass("active");
                return false;
            };

            var show_tooltip = function () {
                $this.parent(".row").find(".active").removeClass("active");

                $this.addClass("active");
            };

            var check_status = function (event) {
                var isActive = $this.hasClass("active");

                if (!isActive) {
                    //Remove all other Tooltips
                    if (!isTeam) {
                        $this
                            .parent(".row")
                            .find(".active")
                            .removeClass("active");
                    }

                    show_tooltip();
                    event.preventDefault();
                    return false;
                }
            };

            init_tooltip();
        });
    };

    //});

    // Get random Element from Selector
    $.fn.randomtest = function () {
        return this.eq(Math.floor(Math.random() * this.length));
    };

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
}

// File Upload Drag & Drop
document.addEventListener("DOMContentLoaded", function () {
    var fileInput = document.getElementById("file_input");
    var fileUpload = document.getElementById("file-upload");
    var fileUploadLabel = document.querySelector(".file-upload-label p");
    var fileUploadInfo = document.querySelector(
        ".file-upload-label .file-upload-info",
    );
    var fileUploadButton = document.querySelector(".file-upload-button");
    var fileUploadIcon = document.querySelector(".file-upload-icon i");
    var maxFileSize = 10 * 1024 * 1024; // 10MB in Bytes
    var allowedFileTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/jpeg",
        "image/jpg",
    ];

    function truncateFileName(fileName, maxLength) {
        if (fileName.length <= maxLength) {
            return fileName;
        }
        var extension = fileName.split(".").pop();
        var nameWithoutExtension = fileName.substring(
            0,
            fileName.length - extension.length - 1,
        );
        return (
            nameWithoutExtension.substring(
                0,
                maxLength - extension.length - 4,
            ) +
            "..." +
            extension
        );
    }

    function validateFile(file) {
        if (!allowedFileTypes.includes(file.type)) {
            fileUploadLabel.textContent =
                "Ungültiger Dateityp. Bitte lade eine PDF, DOC, DOCX oder JPG Datei hoch.";
            fileUploadLabel.classList.add("error");
            resetFileUploadStyles();
            return false;
        }
        if (file.size > maxFileSize) {
            fileUploadLabel.textContent =
                "Die Datei ist zu groß. Bitte lade eine Datei hoch, die kleiner als 10MB ist.";
            fileUploadLabel.classList.add("error");
            resetFileUploadStyles();
            return false;
        }
        fileUploadLabel.classList.remove("error");
        return true;
    }

    function resetFileUploadStyles() {
        fileUpload.classList.remove("file-uploaded");
        fileUpload.style.backgroundColor = "";
        fileUpload.style.borderColor = "";
        fileUploadIcon.className = "fa-light fa-file-arrow-up";
        fileUploadIcon.style.color = "";
        fileUploadButton.textContent = "Datei auswählen";
    }

    function handleFileUpload(files) {
        if (files.length > 0 && validateFile(files[0])) {
            fileInput.files = files; // Dies fügt die Datei tatsächlich zum fileInput hinzu
            fileUploadLabel.textContent = "wird hochgeladen...";
            fileUploadInfo.style.display = "none";
            setTimeout(function () {
                fileUpload.classList.add("file-uploaded");
                fileUpload.style.backgroundColor = "#BBF7D0";
                fileUpload.style.borderColor = "#22c55e";
                fileUploadIcon.className = "fa-light fa-circle-check";
                fileUploadIcon.style.color = "#15803d";
                fileUploadButton.textContent = "Datei ersetzen";
                var truncatedFileName = truncateFileName(files[0].name, 50);
                fileUploadLabel.textContent = truncatedFileName;
            }, 2000);
        } else {
            fileInput.value = ""; // Reset file input if validation fails
        }
    }

    if (fileUpload) {
        //console.log('fileUpload element found');

        fileUpload.addEventListener("dragover", function (e) {
            e.preventDefault();
            e.stopPropagation();
            fileUpload.classList.add("dragover");
            //console.log('dragover event');
        });

        fileUpload.addEventListener("dragleave", function (e) {
            e.preventDefault();
            e.stopPropagation();
            fileUpload.classList.remove("dragover");
            //console.log('dragleave event');
        });

        fileUpload.addEventListener("drop", function (e) {
            e.preventDefault();
            e.stopPropagation();
            fileUpload.classList.remove("dragover");
            var files = e.dataTransfer.files;
            handleFileUpload(files);
            //console.log('drop event', files);
            //console.log('fileInput files:', fileInput.files);
        });

        fileUploadButton.addEventListener("click", function (e) {
            e.preventDefault();
            fileInput.click();
            //console.log('click event');
        });

        fileInput.addEventListener("change", function () {
            var files = fileInput.files;
            handleFileUpload(files);
        });
    } else {
        //console.log('fileUpload element not found');
    }

    if (
        document.getElementById("successBox") ||
        document.getElementById("successBoxJobs")
    ) {
        if (document.getElementById("jobForm")) {
            document
                .getElementById("jobForm")
                .scrollIntoView({ behavior: "smooth" });
        } else if (document.getElementById("angebotForm")) {
            document
                .getElementById("angebotForm")
                .scrollIntoView({ behavior: "smooth" });
        }
    }
});

function setFormSource(value) {
    var formSourceElement = document.getElementById("form_source");
    if (formSourceElement) {
        /*
      var targetButton = event.target;
      if (targetButton.classList.contains('jobForm-disabled')) {
          return; // Nichts tun, wenn der Button die Klasse 'jobForm-disabled' hat
      }
      formSourceElement.value = value;
      document.querySelectorAll('.jobForm-button').forEach(button => {
          button.classList.remove('jobForm-active');
      });
      targetButton.classList.add('jobForm-active');
      */
    }
}

function setFormSourceAndRedirect(value, url) {
    setFormSource(value);
    window.location.href = url;
}

// Funktionen global verfügbar machen
window.setFormSource = setFormSource;
window.setFormSourceAndRedirect = setFormSourceAndRedirect;

// Coded by unlimited.studio – https://unlimited.studio

// Form validation for multiple forms
document.addEventListener("DOMContentLoaded", function () {
    const contactForm = document.getElementById("contact_form");
    const formButton = document.getElementById("form_button");

    if (contactForm && formButton) {
        // Funktion zum Zurücksetzen der Border-Farben
        function resetBorderColors() {
            // Alle möglichen Input-Felder zurücksetzen
            const allInputs = [
                "email_input",
                "name_input",
                "phone_input",
                "subject_input",
                "firstname_input",
                "lastname_input",
                "address_input",
                "zip_input",
                "subject_input_2",
                "start_date",
                "message_input",
                "school_input",
                "training_input",
            ];

            allInputs.forEach((id) => {
                const input = document.getElementById(id);
                if (input) {
                    if (input.tagName === "SELECT") {
                        input.removeAttribute("style");
                    } else {
                        input.style.borderColor = "";
                    }
                }
            });
        }

        // Funktion zum Setzen roter Borders für fehlerhafte Felder
        function setErrorBorders() {
            // Prüfe, welches Formular es ist basierend auf der Action-URL
            const actionUrl = contactForm.action;
            const isJobForm = actionUrl.includes("/job");
            const isAusbildungForm = actionUrl.includes("/ausbildung");
            const isKontaktForm = actionUrl.includes("/kontakt");
            const isLeistungenForm = actionUrl.includes("/leistungen");
            // Robuste Erkennung für Angebotsformular
            const isAngebotForm = /\/angebot(\?|$|\/|$)/.test(actionUrl);

            if (isJobForm) {
                const firstname = document.getElementById("firstname_input");
                const lastname = document.getElementById("lastname_input");
                const email = document.getElementById("email_input");
                const subject = document.getElementById("subject_input");

                if (firstname && !firstname.value.trim()) {
                    firstname.style.borderColor = "red";
                }
                if (lastname && !lastname.value.trim()) {
                    lastname.style.borderColor = "red";
                }
                if (email && !email.value.trim()) {
                    email.style.borderColor = "red";
                }

                if (subject) {
                    const subjectSelectedIndex = subject.selectedIndex;
                    const subjectSelectedOption =
                        subject.options[subjectSelectedIndex];
                    const isSubjectValid =
                        subject.value &&
                        subjectSelectedOption &&
                        !subjectSelectedOption.disabled;

                    if (!isSubjectValid) {
                        subject.setAttribute(
                            "style",
                            "border-color: red !important;",
                        );
                    }
                }
            } else if (isAusbildungForm) {
                // Ausbildungsformular Felder
                const firstname = document.getElementById("firstname_input");
                const lastname = document.getElementById("lastname_input");
                const email = document.getElementById("email_input");
                const phone = document.getElementById("phone_input");
                const address = document.getElementById("address_input");
                const zip = document.getElementById("zip_input");
                const school = document.getElementById("school_input");
                const startDate = document.getElementById("start_date");
                const subject = document.getElementById("subject_input");
                const training = document.getElementById("training_input");
                const subject2 = document.getElementById("subject_input_2");

                if (firstname && !firstname.value.trim()) {
                    firstname.style.borderColor = "red";
                }
                if (lastname && !lastname.value.trim()) {
                    lastname.style.borderColor = "red";
                }
                if (email && !email.value.trim()) {
                    email.style.borderColor = "red";
                }
                if (phone && !phone.value.trim()) {
                    phone.style.borderColor = "red";
                }
                if (address && !address.value.trim()) {
                    address.style.borderColor = "red";
                }
                if (zip && !zip.value.trim()) {
                    zip.style.borderColor = "red";
                }
                if (school && !school.value.trim()) {
                    school.style.borderColor = "red";
                }
                if (startDate && !startDate.value) {
                    startDate.style.borderColor = "red";
                }

                // Prüfe, ob eine gültige Option ausgewählt wurde
                if (subject) {
                    const subjectSelectedIndex = subject.selectedIndex;
                    const subjectSelectedOption =
                        subject.options[subjectSelectedIndex];
                    const isSubjectValid =
                        subject.value &&
                        subjectSelectedOption &&
                        !subjectSelectedOption.disabled;

                    if (!isSubjectValid) {
                        subject.setAttribute(
                            "style",
                            "border-color: red !important;",
                        );
                    }
                }

                if (training) {
                    const trainingSelectedIndex = training.selectedIndex;
                    const trainingSelectedOption =
                        training.options[trainingSelectedIndex];
                    const isTrainingValid =
                        training.value &&
                        trainingSelectedOption &&
                        !trainingSelectedOption.disabled;

                    if (!isTrainingValid) {
                        training.setAttribute(
                            "style",
                            "border-color: red !important;",
                        );
                    }
                }

                if (subject2) {
                    const subject2SelectedIndex = subject2.selectedIndex;
                    const subject2SelectedOption =
                        subject2.options[subject2SelectedIndex];
                    const isSubject2Valid =
                        subject2.value &&
                        subject2SelectedOption &&
                        !subject2SelectedOption.disabled;

                    if (!isSubject2Valid) {
                        subject2.setAttribute(
                            "style",
                            "border-color: red !important;",
                        );
                    }
                }
            } else if (isKontaktForm) {
                // Kontaktformular Felder
                const name = document.getElementById("name_input");
                const email = document.getElementById("email_input");
                const subject = document.getElementById("subject_input");
                const subject2 = document.getElementById("subject_input_2");
                const message = document.getElementById("message_input");

                if (name && !name.value.trim()) {
                    name.style.borderColor = "red";
                }
                if (email && !email.value.trim()) {
                    email.style.borderColor = "red";
                }
                if (message && !message.value.trim()) {
                    message.style.borderColor = "red";
                }

                // Prüfe, ob eine gültige Option ausgewählt wurde
                if (subject) {
                    const subjectSelectedIndex = subject.selectedIndex;
                    const subjectSelectedOption =
                        subject.options[subjectSelectedIndex];
                    const isSubjectValid =
                        subject.value &&
                        subjectSelectedOption &&
                        !subjectSelectedOption.disabled;

                    if (!isSubjectValid) {
                        subject.setAttribute(
                            "style",
                            "border-color: red !important;",
                        );
                    }
                }

                if (subject2) {
                    const subject2SelectedIndex = subject2.selectedIndex;
                    const subject2SelectedOption =
                        subject2.options[subject2SelectedIndex];
                    const isSubject2Valid =
                        subject2.value &&
                        subject2SelectedOption &&
                        !subject2SelectedOption.disabled;

                    if (!isSubject2Valid) {
                        subject2.setAttribute(
                            "style",
                            "border-color: red !important;",
                        );
                    }
                }
            } else if (isAngebotForm) {
                // Angebot-Formular Felder
                const email = document.getElementById("email_input");
                const name = document.getElementById("name_input");
                const phone = document.getElementById("phone_input");
                const subject = document.getElementById("subject_input");

                if (email && !email.value.trim()) {
                    email.style.borderColor = "red";
                }
                if (name && !name.value.trim()) {
                    name.style.borderColor = "red";
                }
                if (phone && !phone.value.trim()) {
                    phone.style.borderColor = "red";
                }

                // Prüfe, ob eine gültige Option ausgewählt wurde
                if (subject) {
                    const subjectSelectedIndex = subject.selectedIndex;
                    const subjectSelectedOption =
                        subject.options[subjectSelectedIndex];
                    const isSubjectValid =
                        subject.value &&
                        subjectSelectedOption &&
                        !subjectSelectedOption.disabled;

                    if (!isSubjectValid) {
                        subject.setAttribute(
                            "style",
                            "border-color: red !important;",
                        );
                    }
                }
            } else if (isLeistungenForm) {
                // Leistungsformular Felder
                const name = document.getElementById("name_input");
                const email = document.getElementById("email_input");
                const subject2 = document.getElementById("subject_input_2");
                const message = document.getElementById("message_input");

                if (name && !name.value.trim()) {
                    name.style.borderColor = "red";
                }
                if (email && !email.value.trim()) {
                    email.style.borderColor = "red";
                }
                if (message && !message.value.trim()) {
                    message.style.borderColor = "red";
                }

                // Prüfe, ob eine gültige Option ausgewählt wurde
                if (subject2) {
                    const subject2SelectedIndex = subject2.selectedIndex;
                    const subject2SelectedOption =
                        subject2.options[subject2SelectedIndex];
                    const isSubject2Valid =
                        subject2.value &&
                        subject2SelectedOption &&
                        !subject2SelectedOption.disabled;

                    if (!isSubject2Valid) {
                        subject2.setAttribute(
                            "style",
                            "border-color: red !important;",
                        );
                    }
                }
            }
        }

        // Event-Listener für Input-Felder zum Zurücksetzen der Border-Farbe
        const allInputs = [
            "email_input",
            "name_input",
            "phone_input",
            "subject_input",
            "firstname_input",
            "lastname_input",
            "address_input",
            "zip_input",
            "subject_input_2",
            "start_date",
            "message_input",
            "school_input",
            "training_input",
        ];

        allInputs.forEach((id) => {
            const input = document.getElementById(id);
            if (input) {
                if (input.tagName === "SELECT") {
                    input.addEventListener("change", function () {
                        this.removeAttribute("style");
                    });
                } else {
                    input.addEventListener("input", function () {
                        this.style.borderColor = "";
                    });
                }
            }
        });

        formButton.addEventListener("click", function (event) {
            // Prüfe, welches Formular es ist
            const actionUrl = contactForm.action;
            const isJobForm = actionUrl.includes("/job");
            const isAusbildungForm = actionUrl.includes("/ausbildung");
            const isKontaktForm = actionUrl.includes("/kontakt");
            const isLeistungenForm = actionUrl.includes("/leistungen");
            // Robuste Erkennung für Angebotsformular
            const isAngebotForm = /\/angebot(\?|$|\/|$)/.test(actionUrl);

            let hasErrors = false;

            if (isJobForm) {
                const firstnameInput =
                    document.getElementById("firstname_input");
                const lastnameInput = document.getElementById("lastname_input");
                const emailInput = document.getElementById("email_input");

                const firstname = firstnameInput
                    ? firstnameInput.value.trim()
                    : "";
                const lastname = lastnameInput
                    ? lastnameInput.value.trim()
                    : "";
                const email = emailInput ? emailInput.value.trim() : "";

                const subject = document.getElementById("subject_input");

                const subjectSelectedIndex = subject
                    ? subject.selectedIndex
                    : -1;
                const subjectSelectedOption = subject
                    ? subject.options[subjectSelectedIndex]
                    : null;
                const isSubjectValid =
                    subject &&
                    subject.value &&
                    subjectSelectedOption &&
                    !subjectSelectedOption.disabled;

                hasErrors =
                    !firstname ||
                    !lastname ||
                    !email ||
                    !isSubjectValid;
            } else if (isAusbildungForm) {
                // Ausbildungsformular Validierung
                const firstnameInput =
                    document.getElementById("firstname_input");
                const lastnameInput = document.getElementById("lastname_input");
                const emailInput = document.getElementById("email_input");
                const phoneInput = document.getElementById("phone_input");
                const addressInput = document.getElementById("address_input");
                const zipInput = document.getElementById("zip_input");
                const schoolInput = document.getElementById("school_input");
                const startDateInput = document.getElementById("start_date");
                const agreeInput = document.getElementById("agree");

                const firstname = firstnameInput
                    ? firstnameInput.value.trim()
                    : "";
                const lastname = lastnameInput
                    ? lastnameInput.value.trim()
                    : "";
                const email = emailInput ? emailInput.value.trim() : "";
                const phone = phoneInput ? phoneInput.value.trim() : "";
                const address = addressInput ? addressInput.value.trim() : "";
                const zip = zipInput ? zipInput.value.trim() : "";
                const school = schoolInput ? schoolInput.value.trim() : "";
                const startDate = startDateInput ? startDateInput.value : "";
                const agree = agreeInput ? agreeInput.checked : false;

                const subject = document.getElementById("subject_input");
                const training = document.getElementById("training_input");
                const subject2 = document.getElementById("subject_input_2");

                // Select-Validierung
                const subjectSelectedIndex = subject
                    ? subject.selectedIndex
                    : -1;
                const subjectSelectedOption = subject
                    ? subject.options[subjectSelectedIndex]
                    : null;
                const isSubjectValid =
                    subject &&
                    subject.value &&
                    subjectSelectedOption &&
                    !subjectSelectedOption.disabled;

                const trainingSelectedIndex = training
                    ? training.selectedIndex
                    : -1;
                const trainingSelectedOption = training
                    ? training.options[trainingSelectedIndex]
                    : null;
                const isTrainingValid =
                    training &&
                    training.value &&
                    trainingSelectedOption &&
                    !trainingSelectedOption.disabled;

                const subject2SelectedIndex = subject2
                    ? subject2.selectedIndex
                    : -1;
                const subject2SelectedOption = subject2
                    ? subject2.options[subject2SelectedIndex]
                    : null;
                const isSubject2Valid =
                    subject2 &&
                    subject2.value &&
                    subject2SelectedOption &&
                    !subject2SelectedOption.disabled;

                hasErrors =
                    !firstname ||
                    !lastname ||
                    !email ||
                    !phone ||
                    !address ||
                    !zip ||
                    !school ||
                    !startDate ||
                    !isSubjectValid ||
                    !isTrainingValid ||
                    !isSubject2Valid ||
                    !agree;
            } else if (isKontaktForm) {
                // Kontaktformular Validierung
                const nameInput = document.getElementById("name_input");
                const emailInput = document.getElementById("email_input");
                const messageInput = document.getElementById("message_input");
                const agreeInput = document.getElementById("agree");

                const name = nameInput ? nameInput.value.trim() : "";
                const email = emailInput ? emailInput.value.trim() : "";
                const message = messageInput ? messageInput.value.trim() : "";
                const agree = agreeInput ? agreeInput.checked : false;

                const subjectSelect = document.getElementById("subject_input");
                const subject2Select =
                    document.getElementById("subject_input_2");

                let isSubjectValid = true;
                let isSubject2Valid = true;

                if (subjectSelect) {
                    const subjectSelectedIndex = subjectSelect.selectedIndex;
                    const subjectSelectedOption =
                        subjectSelect.options[subjectSelectedIndex];
                    isSubjectValid =
                        !!subjectSelect.value &&
                        !!subjectSelectedOption &&
                        !subjectSelectedOption.disabled;
                } else {
                    const hiddenSubject = document.querySelector(
                        'input[name="subject"][type="hidden"]',
                    );
                    isSubjectValid = !!(
                        hiddenSubject && hiddenSubject.value.trim()
                    );
                }

                if (subject2Select) {
                    const subject2SelectedIndex = subject2Select.selectedIndex;
                    const subject2SelectedOption =
                        subject2Select.options[subject2SelectedIndex];
                    isSubject2Valid =
                        !!subject2Select.value &&
                        !!subject2SelectedOption &&
                        !subject2SelectedOption.disabled;
                } else {
                    const hiddenSubject2 = document.querySelector(
                        'input[name="subject_2"][type="hidden"]',
                    );
                    isSubject2Valid = !!(
                        hiddenSubject2 && hiddenSubject2.value.trim()
                    );
                }

                hasErrors =
                    !name ||
                    !email ||
                    !message ||
                    !isSubjectValid ||
                    !isSubject2Valid ||
                    !agree;
            } else if (isAngebotForm) {
                // Angebot-Formular Validierung (original)
                const emailInput = document.getElementById("email_input");
                const nameInput = document.getElementById("name_input");
                const phoneInput = document.getElementById("phone_input");
                const subject = document.getElementById("subject_input");

                const email = emailInput ? emailInput.value.trim() : "";
                const name = nameInput ? nameInput.value.trim() : "";
                const phone = phoneInput ? phoneInput.value.trim() : "";

                // Prüfe, ob eine gültige Option ausgewählt wurde (nicht die Placeholder-Option)
                const subjectValue = subject ? subject.value : "";
                const subjectSelectedIndex = subject
                    ? subject.selectedIndex
                    : -1;
                const subjectSelectedOption = subject
                    ? subject.options[subjectSelectedIndex]
                    : null;
                const isSubjectValid =
                    subjectValue &&
                    subjectSelectedOption &&
                    !subjectSelectedOption.disabled;

                hasErrors = !email || !name || !phone || !isSubjectValid;
            } else if (isLeistungenForm) {
                // Leistungsformular Validierung
                const nameInput = document.getElementById("name_input");
                const emailInput = document.getElementById("email_input");
                const messageInput = document.getElementById("message_input");
                const agreeInput = document.getElementById("agree");

                const name = nameInput ? nameInput.value.trim() : "";
                const email = emailInput ? emailInput.value.trim() : "";
                const message = messageInput ? messageInput.value.trim() : "";
                const agree = agreeInput ? agreeInput.checked : false;

                const subject2 = document.getElementById("subject_input_2");

                // Select-Validierung
                const subject2SelectedIndex = subject2
                    ? subject2.selectedIndex
                    : -1;
                const subject2SelectedOption = subject2
                    ? subject2.options[subject2SelectedIndex]
                    : null;
                const isSubject2Valid =
                    subject2 &&
                    subject2.value &&
                    subject2SelectedOption &&
                    !subject2SelectedOption.disabled;

                hasErrors =
                    !name || !email || !message || !isSubject2Valid || !agree;
            }

            if (hasErrors) {
                event.preventDefault();

                // Border-Farben zurücksetzen und dann fehlerhafte Felder markieren
                resetBorderColors();
                setErrorBorders();

                const errorBox = document.getElementById("formErrorBox");
                const errorMessage =
                    document.getElementById("formErrorMessage");

                if (errorBox && errorMessage) {
                    errorMessage.innerHTML =
                        "Ein Fehler ist aufgetreten, bitte überprüfe die Felder.";
                    errorBox.style.display = "flex";

                    errorBox.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            } else {
                // Alle Border-Farben zurücksetzen wenn keine Fehler
                resetBorderColors();
            }
        });
    }

    document.addEventListener(
        "click",
        function (e) {
            const a = e.target.closest("a[href]");
            if (!a || typeof fbq !== "function") {
                return;
            }
            const href = a.getAttribute("href") || "";
            if (href.startsWith("tel:")) {
                fbq("track", "Contact", {
                    content_name: "phone_click",
                    content_category: "tel",
                });
            } else if (href.startsWith("mailto:")) {
                fbq("track", "Contact", {
                    content_name: "email_click",
                    content_category: "mailto",
                });
            }
        },
        true,
    );
});
